import styled, { css } from 'styled-components';
import InputMask from 'react-input-mask';

const getSemanticSurfaceMuted = ({ theme }) =>
  theme.colors.semantic.surface.muted;

const getSemanticSurfaceCard = ({ theme }) =>
  theme.colors.semantic.surface.card;

const getSemanticTextPrimary = ({ theme }) =>
  theme.colors.semantic.text.primary;

const getSemanticTextSecondary = ({ theme }) =>
  theme.colors.semantic.text.secondary;

const getSemanticBorderDefault = ({ theme }) =>
  theme.colors.semantic.border.default;

const getSemanticActionPrimary = ({ theme }) =>
  theme.colors.semantic.action.primary;

const getSemanticActionFocus = ({ theme }) =>
  theme.colors.semantic.surface.selection;

export const StyledInputMask = styled(InputMask)`
  width: ${props => (props.$maxwidth ? '100%' : '90%')};
  border: 1px solid ${getSemanticBorderDefault};
  color: ${getSemanticTextPrimary} !important;
  background-color: ${getSemanticSurfaceCard} !important;
  -webkit-text-fill-color: ${getSemanticTextPrimary};
  caret-color: ${getSemanticTextPrimary};

  &.form-control {
    border: 1px solid ${getSemanticBorderDefault};
    color: ${getSemanticTextPrimary} !important;
    background-color: ${getSemanticSurfaceCard} !important;
  }

  ::placeholder {
    line-height: 100%;
    letter-spacing: 0.5px;
    color: ${getSemanticTextSecondary};
  }

  &:hover {
    border-color: ${getSemanticActionPrimary};
  }

  &:disabled {
    cursor: not-allowed;
    background-color: ${getSemanticSurfaceMuted} !important;
    border-color: ${getSemanticSurfaceMuted};
    color: ${getSemanticTextSecondary} !important;
    -webkit-text-fill-color: ${getSemanticTextSecondary};
  }

  &:focus,
  &:focus-visible,
  &:focus-within {
    color: ${getSemanticTextPrimary} !important;
    -webkit-text-fill-color: ${getSemanticTextPrimary};
    background-color: ${getSemanticSurfaceCard} !important;
    border-color: ${getSemanticActionPrimary};
    box-shadow: 0 0 0 0.2rem ${getSemanticActionFocus};
  }

  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    transition: background-color 5000s ease-in-out 0s;
    color: ${getSemanticTextPrimary};
    -webkit-text-fill-color: ${getSemanticTextPrimary};
    -webkit-box-shadow: 0 0 0 1000px ${getSemanticSurfaceCard} inset;
  }

  ${props =>
    props.invalid &&
    css`
      border-color: ${props.theme.colors.dangerPrimary};
    `}
`;
